"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapDeals = function mapDeals(dealsSlice) {
  if (!dealsSlice || dealsSlice.length === 0) return false;
  var deals = [];
  dealsSlice.map(function (dealSlice) {
    dealSlice.items.map(function (deal) {
      var _deal$subtitle, _deal$url, _deal$blurhash;
      deals.push({
        title: deal.title && deal.title[0].text,
        subtitle: ((_deal$subtitle = deal.subtitle) === null || _deal$subtitle === void 0 ? void 0 : _deal$subtitle.length) > 0 && deal.subtitle[0].text,
        url: (_deal$url = deal.url) !== null && _deal$url !== void 0 && _deal$url.url ? deal.url.url.replace("https:/", "") : "/",
        image: (0, _image["default"])(deal.image, ((_deal$blurhash = deal.blurhash) === null || _deal$blurhash === void 0 ? void 0 : _deal$blurhash.length) > 0 && deal.blurhash[0].text),
        label: {
          svg: deal.label.url
        }
      });
    });
  });
  return deals;
};
var _default = mapDeals;
exports["default"] = _default;